import { render, staticRenderFns } from "./addSalaryAward.vue?vue&type=template&id=5773b277"
import script from "./addSalaryAward.vue?vue&type=script&lang=js"
export * from "./addSalaryAward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports